/* istanbul ignore file */
import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const resumeGeneratorPlugin = createPlugin({
  id: "resume-generator",
  routes: {
    root: rootRouteRef,
  },
});

export const ResumeGeneratorPage = resumeGeneratorPlugin.provide(
  createRoutableExtension({
    name: "ResumeGeneratorPage",
    component: () =>
      import("./components/ResumeGeneratorComponent").then(
        (m) => m.ResumeGeneratorComponent
      ),
    mountPoint: rootRouteRef,
  })
);
